import React from "react"
import { Button, Currencies, SFXS } from "@orbital/games-frontend-library"
import { Wrapper } from "./styled"
import { BetsRemained } from "./styled"
import { ReactComponent as InfiniteSVG } from "./Vector.svg"

export default function AutoLaunchedBetFooter({
  footerState,
  currency,
  cashoutStake,
  betsRemained,
  funcCashout,
}: any) {
  return (
    <Wrapper footerState={footerState === "cashoutAuto"}>
      <section>
        <Button
          width="237px"
          textColor="#181731;"
          func={(b: boolean) => b && funcCashout()}
          SFX={SFXS.goBackSFX}
        >
          <span>
            CASHOUT {Currencies[currency]}
            {""}
            {cashoutStake}
          </span>
        </Button>
        <BetsRemained>
          {betsRemained}
          {betsRemained === "" && <InfiniteSVG />}
        </BetsRemained>
      </section>
    </Wrapper>
  )
}
